<template>
  <div class="map-header">
    <button
      v-if="!isShowInfoForDetailSection"
      class="map-header__download-button"
      @click="onUploadSchemeImage()"
    >
      {{
        cardSettingsStore.MAP_DOM_RECT.width <= MOBILE_TOP
          ? 'Скачать схему'
          : 'Скачать 2D схему'
      }}
    </button>

    <ContainerCustom class="map-header__container">
      <div class="map-header__tabs-wrapper" v-if="!isShowInfoForDetailSection">
      </div>

      <div class="map-header__back" v-if="isShowInfoForDetailSection">
        <CustomButtonBack @click="backToFullMap()" class="map-header__back-btn">
          Все дома
        </CustomButtonBack>
      </div>

      <ul class="status-list" v-if="isShowInfoForDetailSection">
        <li
          v-for="item in statusList"
          :key="item.id"
          class="status-list__item"
          :class="`status-list__item-${item.status}`"
        >
          <span :style="{ backgroundColor: item.color }" class="status-list__item-circle"></span>
          <p class="status-list__item-text">{{ item.text }}</p>
        </li>
      </ul>

      <div class="map-header__filter" v-if="isShowInfoForDetailSection">
        <CustomListButton class="map-header__filter-list" @click="openList()">Список</CustomListButton>
      </div>
    </ContainerCustom>
  </div>
</template>


<script setup lang="ts">
import { computed } from 'vue';
import CustomListButton from '@/components/commons/CustomControls/CustomListButton.vue';
import CustomButtonBack from '@/components/commons/CustomControls/CustomButtonBack.vue';
import ContainerCustom from '../layouts/ContainerCustom.vue';
import { landPlotStore } from '@/store/modules/LandPLot';
import { cardSettingsStore } from '@/store/modules/CardSettings';
import { MOBILE_TOP } from '@/constants/sizes';

const emits = defineEmits(['openFilter', 'openList', 'changeTab']);

const statusList: Array<{
    id: number;
    text: string;
    status: string;
    color: string;
}> = [
        {
            id: 0,
            text: 'Свободен',
            status: 'success',
            color: '#2BB673',
        },
        {
            id: 1,
            text: 'Забронирован',
            status: 'warning',
            color: '#B9C449',
        },
        {
            id: 2,
            text: 'Занят',
            status: 'danger',
            color: '#D82D2D',
        },
    ];

const isShowInfoForDetailSection = computed(() => {
    return landPlotStore.CURRENT_SECTION_ZONE ? true : false;
});

function backToFullMap() {
    landPlotStore.SET_CURRENT_SECTION_ZONE('');
}

function openList() {
    emits('openList');
}

function onUploadSchemeImage() {
    // const urlFromOtherDomain = `http${
    //     process.env.VUE_APP_COMPONENT_SECURE === 'true' ? 's' : ''
    // }://${process.env.VUE_APP_COMPONENT_DOMAIN}/uploads/scheme_2D.jpg`;
    const urlFromOtherDomain = `http${
        process.env.VUE_APP_COMPONENT_SECURE === 'true' ? 's' : ''
    }://${process.env.VUE_APP_COMPONENT_DOMAIN}/uploads/scheme_2D.jpg`;

    fetch(urlFromOtherDomain)
        .then(res => res.blob())
        .then(blob => {
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            document.body.appendChild(link);
            link.setAttribute('download', 'scheme_2D');
            link.href = url;
            link.click();
            document.body.removeChild(link);
        });
}

</script>

<style lang="less">
.map-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: absolute;
    top: 35px;
    left: 0;
    width: 100%;
    box-sizing: border-box;
    z-index: 10;

    @media (max-width: @size-desktop-top) {
        left: 0;
        top: 20px;
    }

    @media (max-width: @size-mobile-top) {
        top: 15px;
    }

    // .map-header--hide-layout
    &--hide-layout {
        transform: translateX(-100vw);

        &>* {
            transform: translateX(100vw);
        }
    }

    // .map-header--map
    &--map {}

    // .map-header__back
    &__back {

        // .map-header__back-btn
        &-btn {
            @media (max-width: @size-mobile-top) {
            background-color: #F6F6F6;
            width: 29px;
            height: 29px;
            margin-top: -5px;
            }
        }
    }

    &__tabs-wrapper {
        display: flex;
    }

    // .map-header__tabs
    &__tabs {
        display: flex;
        align-items: center;
        position: relative;
        z-index: 10;
        margin-right: 20px;

        @media (max-width: @size-tablet-top) {
            margin-right: 10px;
        }

        // .map-header__tabs-btn
        &-btn {
            background-color: rgba(@simple-light, 0.8);
            padding: 12.5px 21px;
            color: @dark;
            text-transform: uppercase;
            border: 0;
            cursor: pointer;
            font-weight: 600;
            font-size: 12px;
            line-height: 15px;

            @media (max-width: @size-tablet-top) {
                padding: 8px 16px;
                font-size: 10px;
            }

            &--active {
                color: @simple-light;
                background-color: @light-green;
            }

            &:first-child {
                border-top-left-radius: 100px;
                border-bottom-left-radius: 100px;
            }

            &:last-child {
                border-top-right-radius: 100px;
                border-bottom-right-radius: 100px;
            }
        }
    }

    // .map-header__button
    &__button {
        background-color: rgba(@simple-light, 0.8);
        padding: 12.5px 21px;
        color: @dark;
        text-transform: uppercase;
        border: 0;
        border-radius: 100px;
        cursor: pointer;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        @media (max-width: @size-tablet-top) {
            padding: 8px 16px;
            font-size: 10px;
        }

        &--active {
            color: @simple-light;
            background-color: @light-green;
        }
    }

    // .map-header__filter
    &__filter {
        margin-left: auto;
    }

    &__container {
        display: flex;
        gap: 11px;
        align-items: flex-start;
        height: 0;
    }

    &__filter-btn {
        @media (max-width: @size-tablet-top) {
            display: none;
        }
    }

    &__filter-list {
        @media (min-width: @size-desktop-bottom) {
            display: none;
        }
        
        @media (max-width: @size-mobile-top) {
            background-color: #F6F6F6;
            width: 29px;
            height: 29px;
            margin-top: -5px;
            }
    }
}

.status-list {
    position: absolute;
    left: 48px;
    top: 0;
    display: inline-flex;
    flex-direction: column;
    gap: 7px;
    background-color: rgba(@simple-light, 0.8);
    padding: 10px 22px 10px 16px !important;
    margin: 0 !important;

    @media (max-width: 1600px) {
        top: 51px;
        left: auto;
    }

    @media (max-width: @size-desktop-top) {
        padding: 7px 15px 7px 10px;
        gap: 4px;
    }

    @media (max-width: @size-tablet-top) {
        position: static;
        top: auto;
        padding: 6px 12.5px 6px 9.5px;
    }

    @media (max-width: @size-mobile-top) {
        flex-direction: row;
        margin-bottom: -20px !important;
        // padding: 4px 6px;
        background-color: #F6F6F6;
        border-radius: 30px;
        padding: 5px 7px 5px 7px !important;
    }

    &__item {
        display: flex;
        align-items: center;
        gap: 13px;

        @media (max-width: @size-desktop-top) {
            gap: 8px;
        }

        @media (max-width: @size-mobile-top) {
            gap: 2px;
        }
    }

    &__item-circle {
        width: 6px;
        height: 6px;
        border-radius: 100%;

        @media (max-width: @size-desktop-top) {
            width: 4px;
            height: 4px;
        }

        @media (max-width: @size-tablet-top) {
            width: 3.5px;
            height: 3.5px;
        }
    }

    &__item-text {
        font-size: 12px;
        line-height: 18px;
        color: @dark;

        @media (max-width: @size-desktop-top) {
            font-size: 7.5px;
            line-height: 11.5px;
        }

        @media (max-width: @size-tablet-top) {
            font-size: 7px;
            line-height: 10.5px;
        }
    }
}
.map-header__download-button {
  position: absolute;
  top: 0;
  right: 31px; 
  background-color: rgba(@simple-light, 0.8);
  padding: 12.5px 21px;
  color: @dark;
  text-transform: uppercase;
  border: 0;
  border-radius: 100px;
  cursor: pointer;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
  z-index: 20;

  @media (max-width: @size-tablet-top) {
    padding: 8px 16px;
    font-size: 10px;
    right: 15px; 
  }

  &--active {
    color: @simple-light;
    background-color: @light-green;
  }
}


</style>
